<template>
    <transition name="fade">
        <div class="WebsiteDialogue" v-show="websiteDialogueVisible" @click="toggleWebsiteDialogue()">
            <div class="wd-container" @click="$event.stopPropagation()"><!--stopPropagation so toggleWebsiteDialogue() wont trigger on dialogue itself -->
                
                <!-- Toolbar -->
                <div class="wd-bar">
                    <input v-if="showURL" class="wd-bar-link" disabled="false" type="text" v-bind:value="this.url">
                    <div class="wd-bar-buttons">  
                        <md-button class="md-icon-button" @click="openLink()">
                            <OpenInNewIcon class="openInNewIconIcon"/>
                        </md-button>
                        <md-button class="md-icon-button" @click="toggleWebsiteDialogue()" style="margin-right: 0;">
                            <CloseIcon class="closeIcon"/>
                        </md-button>
                    </div> 
                </div>

                <!-- PDF -->
                <iframe class="wd-iframe" id="wd-iframe" v-show="type == 'pdf'" :src="url"/>
                
                <!-- Website -->
                <iframe class="wd-iframe" v-show="type == 'web'" :src="url" frameborder="0" muted="true" autoplay="true"/>


                <video controls class="wd-image wd-iframe" v-show="type == 'video'" :src="url" alt="" muted="true" autoplay="true"/>
                <!-- Image -->
                <img class="wd-image wd-iframe" v-show="type == 'image'" :src="url" alt="">
            </div>         

        </div>  
    </transition>
</template>

<style scoped>
    .WebsiteDialogue{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
        z-index: 5;
    }
    .wd-container{
        margin-top: 40px;
        position: absolute;
        background: white;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
        overflow: hidden;
        width: 88%;
        height: 88%;
    }
    .wd-bar{
        padding: 3px;
        padding-right: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.774);
        display: flex;
        position: relative;
    }
    .wd-bar-link {
        width: calc(90% - 92px);
        padding: 10px;
        border: .5px solid rgb(180, 180, 180);
        background: rgb(241, 241, 241);
        border-radius: 6px;
        font-size: 16px;
        font-family: var(--primaryFont), Helvetica, Arial, sans-serif;
        cursor: text;
    }
    .wd-bar-link::selection{
        color: rgb(238, 238, 238);
    }
    .wd-bar-link:focus {
        outline: none;          
    }
    .wd-bar-buttons{
        margin-left: auto;
    }
    .wd-iframe{
        width: 100%;
        height: calc(100% - 46px);
        overflow-x: hidden;
        border-radius: 0px 0px 10px 10px;
    }
    .wd-image{
        object-fit: contain;
    }
    .material-design-icon {
        height: 2.2em;
        width: 2.2em;
    }
    .material-design-icon > .material-design-icon__svg {
        fill: black;
        height: 2.2em;
        width: 2.2em;
    }
    .v3-active .material-design-icon  > .material-design-icon__svg{
        fill: white !important;
    }
    .v3-active.md-button{
        background: var(--primaryColor);
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
    }
    .material-design-icon.closeIcon {
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.closeIcon> .material-design-icon__svg {
        fill: rgb(252, 113, 113);
        height: 2.5em;
        width: 2.5em;
    }
     .material-design-icon.openInNewIconIcon {
        height: 1.9em;
        width: 1.9em;
    }
    .material-design-icon.openInNewIconIcon> .material-design-icon__svg {
        height: 1.9em;
        width: 1.9em;
    }

    /* Mobile */
    @media (max-device-width: 900px){
        .wd-screen{
            z-index: 99;
        }
    }
</style>
    
<script>
import {mapMutations} from 'vuex';

// Icons
import CloseIcon from 'vue-material-design-icons/Close.vue'
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'

export default {
    components: {CloseIcon,OpenInNewIcon},
    inject: ['toggleCommunication'], 
    data: function () {
        return {
            websiteDialogueVisible: false,
            showURL: true, //Wether url at the top of the dialogue should be visible
            url: "",
            type: "web"
        }
    }, 
	methods: {
        ...mapMutations(["setDialogueOpen"]),

        // Toggles visibility of this dialogue
        toggleWebsiteDialogue(){
            this.websiteDialogueVisible=!this.websiteDialogueVisible;
            this.setDialogueOpen(this.websiteDialogueVisible);

            if(!this.websiteDialogueVisible){
                this.url = "";
                this.showURL = false;
                this.type = "web";
            }        
        },

        // Opens Link in separate window
        openLink(){
            window.open(this.url, '_blank');
        },

        // Displays this dialogue and changes url
        initDialogue: function(e) {
            console.log("initDialogue")
            console.log("type: "+ this.type);
            if(e.detail.url.includes(".mp4")){
              this.type="video"
            }
            this.url = e.detail.url;// + "&autoplay=1&mute=1"; 
            this.showURL = e.detail.showURL;  

            if(this.url.includes('.jpg') || this.url.includes('.png') || this.url.includes('.webp'))
                this.type = "image";
            if(this.url.includes(".pdf")){
                this.type = "pdf";
                this.url = 'https://drive.google.com/viewerng/viewer?embedded=true&url='+this.url;
            }
                

            if(this.type == "pdf"){
                let timerId = setInterval(() => {
                    document.getElementById("wd-iframe").src = document.getElementById("wd-iframe").src;
                }, 1000);

                document.getElementById("wd-iframe").addEventListener('load',() => {
                    clearInterval(timerId);
                });
            }

            this.toggleWebsiteDialogue();
        },
    },

    // Add Eventlistener that displays and initializes this dialogue. Event gets fired inside URLButton component
    mounted: function(){
        window.addEventListener('openURL',this.initDialogue);
    }
}

</script>